<style lang="less" scoped>
@import '../../../style/common/variable';
.dhxwList{position: relative;width: 100%;margin: 0px auto;padding: 0;background: #fff;}
.mains{width: 800px;display: flex;margin: 0px auto;}
.first{display: flex;flex-direction: column;width: 780px;margin-right: 20px;}
.details {text-align: left;}
@media screen and (max-width: @max-screen){
  // .dhxwList{width: 100vw;}
  // .mains{width: 100vw;}
  // .first{width: 96vw;margin: auto;}
  .details{width: 98vw;}
}
</style>

<template>
  <div class="dhxwList">
    <div class="mains">
      <div class="first">
        <Navigation v-if="this._isMobile() " :navigationdatas="navigationListApp"></Navigation>
        <Navigation v-else :navigationdatas="navigationList"></Navigation>
        <Details class="details"></Details>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '../assembly/Navigation'
import Details from '../assembly/Details'
export default {
  components: {Navigation, Details},
  name: '',
  data()
  {
    return {
      navigationList: [
        {theme: '首页', path: '/Kyforum'},
        {theme: '矿业论坛', path: '/Promoin'},
        {theme: '大会新闻', path: '/NewsList'},
        {theme: '正文', path: '/'}
      ],
      navigationListApp: [
        {theme: '首页', path: '/KyforumApp'},
        {theme: '矿业论坛', path: '/PromoinApp'},
        {theme: '大会新闻', path: '/NewsListApp'},
        {theme: '正文', path: '/'}
      ],
      list: []
    }
  },
  methods: {
    // 跳转到大會新聞详情页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/DhxwDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    _isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/DhxwDetails.vue